const Demo6Content6 = () => {
    return (
        <section id="content-6" className="content-6 wide-60 content-section division">
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-md-6 col-lg-5">
                        <div className="txt-block left-column wow fadeInRight">
                            <div className="txt-box mb-30">
                                <h5 className="h5-lg">Creative and Practical</h5>
                                <p className="p-lg">
                                    Quaerat sodales sapien euismod blandit undo vitae ipsum primis and cubilia a laoreet augue and luctus magna dolor egestas luctus
                                    sapien vitae nemo egestas volute and turpis
                                </p>
                            </div>
                            <div className="txt-box">
                                <h5 className="h5-lg">Multiplatform. Always Synced</h5>
                                <ul className="simple-list">
                                    <li className="list-item">
                                        <p className="p-lg">
                                            Fringilla risus, luctus mauris an auctor purus euismod iaculis luctus magna purus pretium ligula and quaerat luctus magna
                                        </p>
                                    </li>
                                    <li className="list-item">
                                        <p className="p-lg">Nemo ipsam egestas volute turpis dolores undo ultrice aliquam quaerat sodales</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-7">
                        <div className="img-block right-column wow fadeInLeft">
                            <img className="img-fluid" src="/images/demo6/img-19.png" alt="content" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Demo6Content6;
